@if (userId) {
  <div class="acx-sip-panel mb-3">
    <div class="d-flex align-items-center justify-content-between gap-2">
      <span class="form-label d-inline-block mb-0 fw-semibold">
        {{ 'AgentManagement::Sip:SectionTitle' | abpLocalization }}
      </span>

      @if (credentials()) {
        <button type="button" class="btn btn-sm btn-link p-0" (click)="hide()">
          {{ 'AgentManagement::Sip:Hide' | abpLocalization }}
        </button>
      }
    </div>

    <small class="text-muted d-block mt-1 mb-2">
      {{ 'AgentManagement::Sip:SectionDescription' | abpLocalization }}
    </small>

    @if (!credentials()) {
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        [disabled]="busy"
        (click)="show()"
      >
        @if (loading()) {
          <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        }
        {{ 'AgentManagement::Sip:Show' | abpLocalization }}
      </button>
    } @else {
      <dl class="acx-sip-panel__fields mb-2">
        <dt>{{ 'AgentManagement::Sip:AuthName' | abpLocalization }}</dt>
        <dd>
          <code>{{ credentials()!.authName }}</code>
          <button
            type="button"
            class="btn btn-sm btn-link p-0 ms-1"
            [pTooltip]="'AgentManagement::Sip:Copy' | abpLocalization"
            (click)="copy(credentials()!.authName)"
          >
            <i class="pi pi-copy" aria-hidden="true"></i>
          </button>
        </dd>

        <dt>{{ 'AgentManagement::Sip:Domain' | abpLocalization }}</dt>
        <dd>
          <code>{{ credentials()!.domain }}</code>
          <button
            type="button"
            class="btn btn-sm btn-link p-0 ms-1"
            [pTooltip]="'AgentManagement::Sip:Copy' | abpLocalization"
            (click)="copy(credentials()!.domain)"
          >
            <i class="pi pi-copy" aria-hidden="true"></i>
          </button>
        </dd>

        <dt>{{ 'AgentManagement::Sip:Extension' | abpLocalization }}</dt>
        <dd>
          @if (credentials()!.extension) {
            <code>{{ credentials()!.extension }}</code>
          } @else {
            <span class="text-muted">
              {{ 'AgentManagement::Sip:NoExtension' | abpLocalization }}
            </span>
          }
        </dd>

        <dt>{{ 'AgentManagement::Sip:Secret' | abpLocalization }}</dt>
        <dd>
          @if (credentials()!.secret) {
            <code>{{ credentials()!.secret }}</code>
            <button
              type="button"
              class="btn btn-sm btn-link p-0 ms-1"
              [pTooltip]="'AgentManagement::Sip:Copy' | abpLocalization"
              (click)="copy(credentials()!.secret)"
            >
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          } @else {
            <span class="text-muted">
              {{ 'AgentManagement::Sip:NotProvisioned' | abpLocalization }}
            </span>
          }
        </dd>

        <dt>{{ 'AgentManagement::Sip:VoicemailPin' | abpLocalization }}</dt>
        <dd>
          @if (credentials()!.voicemailPin) {
            <code>{{ credentials()!.voicemailPin }}</code>
            <button
              type="button"
              class="btn btn-sm btn-link p-0 ms-1"
              [pTooltip]="'AgentManagement::Sip:Copy' | abpLocalization"
              (click)="copy(credentials()!.voicemailPin)"
            >
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          } @else {
            <span class="text-muted">
              {{ 'AgentManagement::Sip:NotProvisioned' | abpLocalization }}
            </span>
          }
        </dd>
      </dl>

      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        [disabled]="busy"
        (click)="rotate()"
      >
        @if (rotating()) {
          <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        }
        {{ 'AgentManagement::Sip:Rotate' | abpLocalization }}
      </button>
    }
  </div>
}
